import root from 'window-or-global';

export const fetchOrGetCached = async (fetchFn, key) => {
    let keyValueStore;

    if (!root.__server_side_render && root.indexedDB) {
        keyValueStore = require('./KeyValueStore').default; // eslint-disable-line global-require
    }

    try {
        const result = await fetchFn();
        if (keyValueStore) keyValueStore.set(key, result);
        return result;
    } catch (e) {
        if (keyValueStore) {
            return keyValueStore && keyValueStore.get(key);
        }
        throw e;
    }
};

export const bulkFetchOrGetCached = fetchOrGetConfig => {
    return Promise.all(fetchOrGetConfig.map(x => fetchOrGetCached(x.fetchFn, x.key)));
};

export default {
    fetchOrGetCached
};
